import { render, staticRenderFns } from "./SampleSearch.vue?vue&type=template&id=1841d9c6&scoped=true"
import script from "./SampleSearch.vue?vue&type=script&lang=js"
export * from "./SampleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841d9c6",
  null
  
)

export default component.exports